var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"mynav"},[_c('van-nav-bar',{staticClass:"van-hairline--bottom-none white-van-icon",style:({
      background: 'rgba(0, 0, 0, 0)'
    }),attrs:{"left-arrow":""},on:{"click-left":_vm.onClickLeftHandler}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }